import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  MonitorRunDetailDto,
  PagedModelMonitorRunSummaryDto,
} from '@kortxio/hub-api';
import { reportApiError } from 'features/shared/reportApiError';
import api from 'libs/api';
import { AsyncThunkConfig } from 'store/types';

export const getMonitorRuns = createAsyncThunk<
  PagedModelMonitorRunSummaryDto,
  { monitorKey?: string; page: number },
  AsyncThunkConfig
>(
  'monitoringRuns/getMonitorRuns',
  async ({ monitorKey, page }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.monitorRun.getMonitorRuns(monitorKey, page);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);

export const getMonitorRun = createAsyncThunk<
  MonitorRunDetailDto,
  { runId: string },
  AsyncThunkConfig
>(
  'monitoringRuns/getMonitorRun',
  async ({ runId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.monitorRun.getMonitorRunById(runId);

      return response.data;
    } catch (error) {
      return rejectWithValue(reportApiError(error, dispatch));
    }
  }
);
